import CommonHeader from '../components/common/CommonHeader';
import CommonFooter from '../components/common/CommonFooter';
import SearchBox from '../components/common/SearchBox';
import Meta from '../components/common/Meta';
import BlogRequests from '../components/blog-requests/BlogRequests';
import { getURLParameter } from '../utils/CommonUtil';

const meta = {
    title: '审核结果 - 博客中心',
    keywords: '博客收录申请',
    description: '博客收录申请审核结果查询。',
};

export default function BlogRequestsPage() {
    const approved = getURLParameter('approved') === 'true';

    return (
        <div className="redesign-page">
            <Meta meta={meta} />
            <CommonHeader />
            <main>
                <div className="redesign-container">
                    <header className="redesign-page-header">
                        <h1 className="redesign-page-title">审核结果</h1>
                        <p className="redesign-page-desc">
                            这里会列出所有已提交的博客与审核结果。若被驳回，请按提示修改后重新提交。
                        </p>
                    </header>

                    {approved && (
                        <div className="redesign-success-banner">
                            <span className="redesign-success-icon">✓</span>
                            您提交的博客已被收录！
                        </div>
                    )}

                    <SearchBox placeholder="搜索已提交的博客…" gotoPage="/blog-requests" />
                    <BlogRequests />
                </div>
            </main>
            <CommonFooter />
        </div>
    );
}
